import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Countdown } from './Countdown';
import { Check, ChevronDown, ChevronUp } from 'lucide-react';
const comparisonData = [{
  sit: 'No terminás nada en el día',
  without: '3 horas drenadas sin darte cuenta',
  with: 'Auditoría del Tiempo — recuperás esas horas'
}, {
  sit: 'La casa en caos permanente',
  without: 'Limpieza interminable que no alcanza',
  with: 'Protocolo S.O.S. — funcional en 15 minutos'
}, {
  sit: 'Dormís mal aunque el bebé duerme',
  without: 'Sin sistema — cada noche es un accidente',
  with: 'Regla de los 90 minutos + Turno de Oro'
}, {
  sit: 'La pareja no sabe cómo ayudar',
  without: '"Avisame si necesitás algo" — nunca funciona',
  with: 'Delegación Radical — tareas concretas y horarios'
}, {
  sit: 'Sin organización semanal',
  without: 'Cada día improvisado desde cero',
  with: 'Plantillas de horario listas para usar'
}];
export function PricingSection() {
  const [isMamaControlOpen, setIsMamaControlOpen] = useState(false);
  return <section id="pricing" className="py-24 px-4 bg-brand-darker relative" data-id="element-168">
      <div className="max-w-6xl mx-auto" data-id="element-169">
        {/* Urgency Section */}
        <div className="text-center mb-16" data-id="element-170">
          <h2 className="text-2xl md:text-3xl font-bold text-brand-accent mb-8" data-id="element-171">
            ⏰ PRECIO DE LANZAMIENTO — CIERRA EN:
          </h2>

          <div className="mb-8" data-id="element-172">
            <Countdown data-id="element-173" />
          </div>

          <p className="text-xl text-brand-cream-light mb-6 flex items-center justify-center gap-2" data-id="element-174">
            <span className="text-2xl" data-id="element-175">⚠️</span> Después sube $10.000. No
            vuelve.
          </p>

          <div className="max-w-md mx-auto bg-brand-dark p-4 rounded-xl border border-brand-primary/20" data-id="element-176">
            <div className="flex justify-between text-sm mb-2 text-brand-cream" data-id="element-177">
              <span data-id="element-178">Cupos tomados</span>
              <span className="font-bold text-brand-accent" data-id="element-179">72%</span>
            </div>
            <div className="h-3 bg-brand-darker rounded-full overflow-hidden" data-id="element-180">
              <motion.div initial={{
              width: 0
            }} whileInView={{
              width: '72%'
            }} viewport={{
              once: true
            }} transition={{
              duration: 1.5,
              ease: 'easeOut'
            }} className="h-full bg-red-500 rounded-full" data-id="element-181" />
            </div>
            <p className="text-xs text-brand-primary mt-2" data-id="element-182">
              🔴 72% de los cupos al precio de lanzamiento ya tomados
            </p>
          </div>
        </div>

        <div className="text-center mb-12" data-id="element-183">
          <h2 className="text-4xl md:text-5xl font-serif text-brand-cream-light" data-id="element-184">
            ELEGÍ TU PACK
          </h2>
        </div>

        {/* Pricing Cards */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 max-w-5xl mx-auto mb-12" data-id="element-185">
          {/* Card 1 */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-brand-dark rounded-3xl p-8 border border-brand-primary/20 flex flex-col" data-id="element-186">
            <div className="mb-6" data-id="element-187">
              <h3 className="text-2xl font-bold text-brand-cream-light mb-2 flex items-center gap-2" data-id="element-188">
                🍼 S.O.S. LACTANCIA PACK
              </h3>
              <p className="text-brand-accent font-medium" data-id="element-189">6 Tomos + 6 Bonos</p>
              <p className="text-brand-primary mt-4" data-id="element-190">
                Para mamás que quieren dominar la lactancia completa
              </p>
            </div>

            <div className="my-8" data-id="element-191">
              <p className="text-brand-primary/60 line-through text-xl mb-1" data-id="element-192">
                $89.000
              </p>
              <div className="flex items-baseline gap-2" data-id="element-193">
                <span className="text-5xl font-serif text-brand-cream-light font-bold" data-id="element-194">
                  $19.990
                </span>
                <span className="text-brand-primary font-bold" data-id="element-195">ARS</span>
              </div>
            </div>

            <div className="mt-auto" data-id="element-196">
              <a href="https://www.mamasincaos.store/cart/53013040890153:1" target="_blank" rel="noopener noreferrer" className="block w-full py-4 rounded-xl border-2 border-brand-accent text-brand-accent font-bold text-lg hover:bg-brand-accent hover:text-brand-darker transition-colors text-center" data-id="element-197">
                → QUIERO MI S.O.S. LACTANCIA PACK
              </a>
            </div>
          </motion.div>

          {/* Card 2 - Highlighted */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="bg-gradient-to-b from-brand-primary/20 to-brand-dark rounded-3xl p-8 border-2 border-brand-gold relative flex flex-col shadow-[0_0_30px_rgba(212,168,83,0.15)]" data-id="element-198">
            <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-brand-gold text-brand-darker px-4 py-1 rounded-full text-sm font-bold tracking-wide uppercase shadow-lg" data-id="element-199">
              Más elegido
            </div>

            <div className="mb-6" data-id="element-200">
              <h3 className="text-2xl font-bold text-brand-cream-light mb-2 flex items-start gap-2" data-id="element-201">
                🏆 S.O.S. LACTANCIA + MAMÁ BAJO CONTROL ⭐
              </h3>
              <p className="text-brand-gold font-medium" data-id="element-202">
                6 Tomos + 6 Bonos + Sistema de Gestión del Postparto
              </p>
              <p className="text-brand-primary mt-4" data-id="element-203">
                Para mamás que además del dolor quieren recuperar el tiempo y la
                paz mental
              </p>
            </div>

            <div className="my-8" data-id="element-204">
              <p className="text-brand-primary/60 line-through text-xl mb-1" data-id="element-205">
                $119.000
              </p>
              <div className="flex items-baseline gap-2" data-id="element-206">
                <span className="text-6xl font-serif text-brand-gold font-bold" data-id="element-207">
                  $27.990
                </span>
                <span className="text-brand-primary font-bold" data-id="element-208">ARS</span>
              </div>
            </div>

            <div className="mt-auto" data-id="element-209">
              <a href="https://www.mamasincaos.store/cart/53013045117225:1" target="_blank" rel="noopener noreferrer" className="block w-full py-5 rounded-xl bg-brand-gold text-brand-darker font-bold text-xl hover:bg-[#e5b964] transition-colors shadow-lg hover:scale-[1.02] transform duration-200 text-center" data-id="element-210">
                → QUIERO EL PACK COMPLETO
              </a>
            </div>
          </motion.div>
        </div>

        {/* Mama Bajo Control Expansion */}
        <div className="max-w-4xl mx-auto" data-id="element-211">
          <button onClick={() => setIsMamaControlOpen(!isMamaControlOpen)} className="w-full bg-brand-dark border border-brand-primary/30 rounded-xl p-6 flex items-center justify-between hover:bg-brand-dark/80 transition-colors" data-id="element-212">
            <span className="text-xl md:text-2xl font-serif text-brand-cream-light flex items-center gap-3" data-id="element-213">
              🕊️ ¿QUÉ AGREGA "MAMÁ BAJO CONTROL"?
            </span>
            {isMamaControlOpen ? <ChevronUp className="text-brand-accent" data-id="element-214" /> : <ChevronDown className="text-brand-accent" data-id="element-215" />}
          </button>

          <AnimatePresence data-id="element-216">
            {isMamaControlOpen && <motion.div initial={{
            height: 0,
            opacity: 0
          }} animate={{
            height: 'auto',
            opacity: 1
          }} exit={{
            height: 0,
            opacity: 0
          }} className="overflow-hidden" data-id="element-217">
                <div className="bg-brand-darker border-x border-b border-brand-primary/30 rounded-b-xl p-6 md:p-8 mt-[-10px] pt-10" data-id="element-218">
                  <div className="overflow-x-auto" data-id="element-219">
                    <table className="w-full text-left border-collapse" data-id="element-220">
                      <thead data-id="element-221">
                        <tr className="border-b border-brand-primary/20" data-id="element-222">
                          <th className="pb-4 text-brand-primary font-medium w-1/3" data-id="element-223">
                            Situación
                          </th>
                          <th className="pb-4 text-red-400/80 font-medium w-1/3 px-4" data-id="element-224">
                            ❌ Sin el sistema
                          </th>
                          <th className="pb-4 text-brand-accent font-medium w-1/3 px-4" data-id="element-225">
                            ✅ Con Mamá Bajo Control
                          </th>
                        </tr>
                      </thead>
                      <tbody data-id="element-226">
                        {comparisonData.map((row, i) => <tr key={i} className="border-b border-brand-primary/10 last:border-0" data-id="element-227">
                            <td className="py-4 text-brand-cream-light font-medium pr-4" data-id="element-228">
                              {row.sit}
                            </td>
                            <td className="py-4 text-brand-primary/80 px-4" data-id="element-229">
                              {row.without}
                            </td>
                            <td className="py-4 text-brand-accent px-4 font-medium" data-id="element-230">
                              {row.with}
                            </td>
                          </tr>)}
                      </tbody>
                    </table>
                  </div>
                </div>
              </motion.div>}
          </AnimatePresence>
        </div>
      </div>
    </section>;
}